import React from 'react';
import { connect } from 'react-redux';
import {
	addErrorAlert,
	toggleGlobalLoader,
	clearAllAlerts,
} from '../../../store/calls/alertLoadingDispatch';
import * as actions from '../../../store/actions';
import validators from '../../../utils/forms/validators';
import api from '../../../store/api';

// Local Components
import PublicWrapper from '../../theme/wrappers/PublicWrapper';
import BaseForm from '../../theme/forms/BaseForm';
import OTPForm from "../../subcomponents/auth/OTPForm";
import TestWrapper from "../../../utils/testUtils/TestWrapper";

class PasswordResetScreen extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			step: 1,
			otp_verified: false,
		};

		this.formDataStore = {};

		this.inputs = {
			1: [
				{
					type: 'text',
					dataKey: 'email',
					label: 'Enter the email associated with your account',
					inputClasses: 'is-medium',
					...validators.isEmail,
				},
			],
			2: [
				{
					type: 'text',
					dataKey: 'otp',
					label: 'Enter the code we just emailed you',
					inputClasses: 'is-medium',
					errorText: 'Must be a six digit number',
					validator: val => validators.isNumber.validator(val) && `${val}`.length === 6
				},
			],
			3: [
				{
					type: 'password',
					dataKey: 'password',
					label: 'Enter your new password',
					inputClasses: 'is-medium',
					...validators.isStringOfMinLength(6),
				},
				{
					type: 'password',
					dataKey: 'password_confirm',
					label: 'Confirm your new password',
					inputClasses: 'is-medium',
					validator: (val, formState) => {
						console.log("validation check", formState, val)
						return formState.password === val
					},
					errorText: "The two passwords must match."
				},
			],
		};
	}

	componentDidMount() {
		toggleGlobalLoader(false);
	}

	resetPassword = (formData) => {
		api
			.post('auth/request-reset/', {
				...formData,
				email: this.formDataStore.email,
				otp: this.formDataStore.otp,
			})
			.then(() => {
				window.location.href = '/my-projects';
			})
			.catch((err) => {
				clearAllAlerts();
				if (!err.response) {
					addErrorAlert('We seem to have trouble connecting', 10 * 1000);
				} else {
					addErrorAlert(err.response.data.error, 5 * 1000);
				}
			});
	};

	renderStep1 = () => {
		const { step } = this.state;
		const { loading } = this.props;

		const onSubmit = (data) => {
			this.formDataStore.email = data.email;
			this.setState({ step: 2 });
		}
		return (
			<BaseForm
				inputs={this.inputs[step]}
				hideDefaultButtons
				onSubmit={onSubmit}
				otherButtons={
					<button
						className={`button is-primary is-fullwidth is-medium ${
							loading ? 'is-loading' : ''
						}`}
						type="submit"
					>
						Get One Time Password Reset Token
					</button>
				}
			/>
		);
	};

	renderStep2 = () => {
		const { loading } = this.props;
		const onSuccess = ({user, tokens, email, otp}) => {
			this.formDataStore.otp = otp;
			this.setState({step: 3})
		}
		return (
			<OTPForm
					email={this.formDataStore.email}
					onSuccess={onSuccess}
				/>
		);
	};

	renderStep3 = () => {
		const { step } = this.state;
		const { loading } = this.props;
		return (
			<BaseForm
				inputs={this.inputs[step]}
				hideDefaultButtons
				onSubmit={this.resetPassword}
				otherButtons={
					<button
						className={`button is-primary is-fullwidth is-medium ${
							loading ? 'disabled' : ''
						}`}
						type="submit"
					>
						Change Password
					</button>
				}
			/>
		);
	};

	render() {
		const { step } = this.state;
		return (
			<PublicWrapper showNav={false} cornerCoverStyle={{ zIndex: 2 }}>
				<section className="hero is-fullheight" id="password-reset-hero">
					<div className="hero-body" style={{ zIndex: 2 }}>
						<div className="container" style={{ maxWidth: '500px' }}>
							<div className="box">
								<div className="hero-logo is-centered small mb-4" />
								{step === 1 && this.renderStep1()}
								{step === 2 && this.renderStep2()}
								{step === 3 && this.renderStep3()}
							</div>
						</div>
					</div>
				</section>
			</PublicWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: false,
	error: state.user.error,
	focusedProject: state.projectLeads.focusedProject,
});

const mapDispatchToProps = (dispatch) => ({
	updateTokenData: (data) => dispatch(actions.user.updateTokenData(data)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PasswordResetScreen);
